import { updateBindStatus } from '../mutators/updateBindStatus';
import Datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';

export function completeLinkedInBind(error: string): void {
    const { name: eventName, customData: customData } = Datapoints.linkedInBindComplete.datapoint;
    logUsage(eventName, customData(error));
    updateBindStatus(error ? 'Unbound' : 'Bound');
}
